import { TOtpStore } from '~/store/otp-verification/types.ts';

export const otpVerificationStatusActionsFulfilled = (state: TOtpStore) => {
  state.loading = false;
  state.error = null;
  state.status = '';
};

export const otpVerificationStatusActionsPending = (state: TOtpStore) => {
  state.loading = true;
};
